import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'copo-datacenter-view-cancel-dialog',
	templateUrl: './datacenter-view-cancel-dialog.component.html',
	encapsulation: ViewEncapsulation.Emulated,

	imports: [MatDialogModule, TranslateModule, MatButtonModule]
})
export class DatacenterViewCancelDialogComponent {
	constructor(public dialogRef: MatDialogRef<DatacenterViewCancelDialogComponent>) {}

	close() {
		this.dialogRef.close();
	}

	save() {
		this.dialogRef.close(true);
	}
}
